import React, { useState } from "react";
import { apiRequest } from "../lib/api";

export function ExtensionWaitlist() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle");
  const [message, setMessage] = useState("");

  const submit = async (event) => {
    event.preventDefault();
    if (status === "submitting") return;
    setStatus("submitting");
    setMessage("");
    try {
      await apiRequest("/api/theofast/extension-waitlist", { method: "POST", body: JSON.stringify({ email }) });
      setStatus("success");
      setMessage("You’re on the list.");
      setEmail("");
    } catch (error) {
      setStatus("error");
      setMessage(error.message);
    }
  };

  return (
    <section className="extension-waitlist" aria-labelledby="extension-waitlist-title">
      <div>
        <span className="eyebrow">Coming soon</span>
        <h2 id="extension-waitlist-title">Auto-Speed Extension for YouTube</h2>
        <p>Automatic speed changes, right inside YouTube.</p>
      </div>
      <form onSubmit={submit}>
        <label className="sr-only" htmlFor="extension-email">Email address</label>
        <input id="extension-email" type="email" autoComplete="email" required maxLength="254" value={email} onChange={(event) => setEmail(event.target.value)} placeholder="you@example.com" disabled={status === "submitting"} />
        <button type="submit" disabled={status === "submitting"}>{status === "submitting" ? "Joining…" : "Join waitlist"}</button>
        <span className={status === "error" ? "is-error" : ""} role="status" aria-live="polite">{message}</span>
      </form>
    </section>
  );
}
